import React from "react"

const CachedQueryParamsContext = React.createContext({})

export default CachedQueryParamsContext
